import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Unauthorized = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="text-center p-4 shadow-lg rounded bg-white" style={{ maxWidth: "500px" }}>
        <div className="mb-4">
          <i className="bi bi-shield-lock-fill text-danger" style={{ fontSize: "4rem" }}></i>
        </div>
        <h1 className="display-5 fw-bold text-danger">403</h1>
        <h2 className="mb-3">Unauthorized Access</h2>
        <p className="text-muted mb-4">
          Oops! You don’t have permission to view this page.  
          Please check your role or return to a safe page.
        </p>
        <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
          <Link to="/" className="btn btn-primary bg-dark px-4">
            <i className="bi bi-house-door-fill me-2"></i> Go Home
          </Link>
          {/* <Link to="/user/new" className="btn btn-outline-secondary px-4">
            <i className="bi bi-chat-dots-fill me-2"></i> Open Chat
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
